import { render, staticRenderFns } from "./AcceptInvitation.vue?vue&type=template&id=13fd32b8"
import script from "./AcceptInvitation.vue?vue&type=script&lang=js"
export * from "./AcceptInvitation.vue?vue&type=script&lang=js"
import style0 from "./AcceptInvitation.vue?vue&type=style&index=0&id=13fd32b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports